import React, { useState } from "react";
import { Stack, Typography, Box } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import QueryPresetCard from "./QueryPresetCard";
import QueryPresetBrowseCard from "./QueryPresetBrowseCard";
import QueryPresetGalleryDialog from "./QueryPresetGalleryDialog";

const QueryPresetRow = ({ onApply, activePresetId, featuredPresets = [], presets = [] }) => {
  const [galleryOpen, setGalleryOpen] = useState(false);

  return (
    <Box sx={{ mb: 3 }}>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "flex-start", sm: "center" }}
        justifyContent="space-between"
        spacing={1}
        sx={{ mb: 1.5 }}
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          <AutoAwesomeIcon color="primary" fontSize="small" />
          <Typography variant="subtitle1" fontWeight={700}>
            Quick starts
          </Typography>
        </Stack>
        <Typography variant="caption" color="text.secondary">
          Tap a card to run · open the library for {presets.length} more
        </Typography>
      </Stack>

      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={1.5}
        useFlexGap
        flexWrap="wrap"
        alignItems="stretch"
      >
        <Box
          sx={{
            flex: { xs: "1 1 auto", sm: "1.2 1 240px" },
            minWidth: { sm: 240 },
            display: "flex",
          }}
        >
          <QueryPresetBrowseCard
            totalCount={presets.length}
            onClick={() => setGalleryOpen(true)}
          />
        </Box>
        {featuredPresets.map((preset) => (
          <Box
            key={preset.id}
            sx={{ flex: "1 1 180px", minWidth: 180, display: "flex" }}
          >
            <QueryPresetCard
              preset={preset}
              compact
              selected={activePresetId === preset.id}
              onClick={onApply}
            />
          </Box>
        ))}
      </Stack>

      <QueryPresetGalleryDialog
        open={galleryOpen}
        onClose={() => setGalleryOpen(false)}
        onSelect={onApply}
        activePresetId={activePresetId}
        presets={presets}
      />
    </Box>
  );
};

export default QueryPresetRow;
